// extracted by mini-css-extract-plugin
export var container = "_kg-0";
export var outlet = "_kg-1";
export var outletEnter = "_kg-2";
export var outletEnterActive = "_kg-3";
export var outletExit = "_kg-4";
export var outletExitActive = "_kg-5";